import axios from "../utils/axios";

export class UsersService {
  createUser(data: any) {
    return axios.post("/users", data);
  }
  getAllUsers(params?: Record<string, any>) {
    return axios.get("/users", { params });
  }
  updateUser(data: any, id?: string) {
    return axios.patch(`/users${id ? `?userId=${id}` : ""}`, data);
  }
  deleteUser(id?: string) {
    return axios.delete(`/users/${id}`);
  }
}
